import React from 'react'
import ListLink from '../../components/listLink/listLink'
import {PREFIX_REPOSITORY,POSTFIX_REPOSITORY} from '../../constants/URLs';

const dataLink = [
  {
      title: 'Encuentra aquí la relación de las empresas y socios comerciales del Grupo Credicorp.',
      link: PREFIX_REPOSITORY + '2024/pdf/' + 'Lista-de-empresas-socios-comerciales.pdf' + POSTFIX_REPOSITORY
  }
]  

const EmpresasSocios = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Empresas y Socios Comerciales
        </h2>
        <div className='tw-mb-4 tw-mb-4@lg'>
          {dataLink.map(({ title, link }) => (
              <ListLink title={title} link={link} key={title} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default EmpresasSocios
